import Vue from 'vue'
import moment from 'moment'
import con from '../const.js'

function reset_chat_upload_data(state){
	state.chat_upload.popup = false;
	state.chat_upload.started = false;
	state.chat_upload.msg = ''
	state.chat_upload.path = ''
	state.chat_upload.status = 0
	state.chat_upload.data.file_url = ''
	state.chat_upload.data.file_type = ''
	state.chat_upload.data.file_size = ''
}

function save_chat_upload_state(state){
	Vue.localStorage.set(con.CU_KEY,JSON.stringify(state.chat_upload))
}

function clear_chat_upload_state(){
	Vue.localStorage.remove(con.CU_KEY)
}

function updateGlobalVar(state,{name,data}){
	if(name == 'areas'){
		try{
			let areas = []
			data.forEach(item=>{
    			if(item.level === 1){
    				areas.push({
    					value: item.area_id,
    					label: item.name,
    					children: []
    				})
    			}
    			if(item.level === 2){
    				let parea = areas.find(child=>child.value === item.parent_id)
    				if(parea && parea.children){
    					parea.children.push({
    						value: item.area_id,
	    					label: item.name,
	    					children: []
    					})
    				}          				            										
    			}
    			if(item.level === 3){  
    				let parent = data.find(di=>di.area_id === item.parent_id)
    				let top    = areas.find(ci=>ci.value === parent.parent_id)  
    				let top_children = top.children.find(si=>si.value === item.parent_id) 
    				if(top_children && top_children.children){
    					top_children.children.push({
    						value: item.area_id,
    						label: item.name
    					})
    				}						
    			}            			
    		})
    		Vue.set(state.gvars,name,areas)
    	}catch(e){
    	}
    }else{	
		Vue.set(state.gvars,name,data)
	}
}

export default {	
	setSysName(state,data){
		state.sys_name = data
	},
	setUiConfig(state,config){
		state.ui_config = config
	},
	setLoginInfo(state,data){
		state.user.info = data
		state.ws_host = data.ws_host
		state.base_url = data.base_url
		state.user.token = data.token
		state.user.login_time = Math.floor((new Date()).getTime()/1000)
		state.user.login_server_time = data.login_server_time
		state.user.expire_time = data.expired
		Vue.localStorage.set(con.LSKEY,JSON.stringify(state.user))
		Vue.http.headers.common['x-token'] = data.token;
		Vue.http.headers.common['x-sid'] = String(data.default_sid)
		Vue.http.headers.common['x-sub-host'] = String(data.x_sub_host)
		//建立socket连接
//		if(!state.socket.isConnected){
//			Vue.ws.connect(state.ws_host)
//		}else{
//			if(!state.socket.isUserOnline){
//				Vue.ws.sendEvent('online',{token:state.user.token,client_type:'mobile'})
//			}
//		}
	},	
	clearLoginInfo(state){
		state.user.info = null
		state.user.login_time  = 0
		state.user.login_server_time = 0
		state.user.expire_time = 0
		state.user.token = ''
		Vue.localStorage.remove(con.LSKEY)
		Vue.localStorage.remove('student_login_params')
		delete Vue.http.headers.common['x-token']
		delete Vue.http.headers.common['x-sid'] 
//		Vue.ws.close()
	},
	setArchiveInfo (state,data) {
		state.user.info.default_sid = data
		Vue.http.headers.common['x-sid'] = String(data)
		Vue.localStorage.set(con.LSKEY,JSON.stringify(state.user))
	},
	setGlobalVars(state,globals){
		for(let o in globals){
			updateGlobalVar(state,{name:o,data:globals[o]})
		}
		Vue.localStorage.set('gvars',JSON.stringify(state.gvars))
	},
	setNotice(state,notice){		
		let NOTICEKEY = moment(new Date()).format('YYYYMMDD')+'_NOTICE'		
		let NOTICECACHE = moment(new Date()).subtract(1,'days')+'_NOTICE'
		let data = Vue.localStorage.get(NOTICEKEY)
		
		if(notice){
			state.user.notice = notice
			Vue.localStorage.remove(NOTICECACHE)		
			Vue.localStorage.set(NOTICEKEY,JSON.stringify(notice))			
		}else if(data){
			state.user.notice = JSON.parse(data)
		}
	},
	clearNotice(state,type){
		let NOTICEKEY = moment(new Date()).format('YYYYMMDD')+'_NOTICE'	
		let field = 'today_'+type+'_num'
		
		state.user.notice[field] = 0
		Vue.localStorage.set(NOTICEKEY,JSON.stringify(state.user.notice))
	},
	updateUserOpenid(state,openid){
		state.user.info.openid = openid
		Vue.localStorage.set(con.LSKEY,JSON.stringify(state.user))
	},
	setSession(state,{name,value}){
		state.session[name] = value
	},
	removeSession(state,name){
		delete state.session[name]
	},
	updateUserInfo(state,{user,action}){		
		switch(action){
			case 'changeName':
				state.user.info.name = user.name
				break;
			case 'changeAvatar':
				state.user.info.avatar = user.avatar
				break;
			case 'updateArchives':
				state.user.info.students = user
				break;
			case 'changeMobile':
				state.user.info.mobile = user.mobile
				break;
		}
		
		Vue.localStorage.set(con.LSKEY,JSON.stringify(state.user))
	},
	setWxToken(state,{openid}){
		state.user.info.is_weixin_bind = 1
		state.user.info.openid = openid
		Vue.localStorage.set(con.LSKEY,JSON.stringify(state.user))
	},
	updateLoadingStatus(state, payload){
    	state.isLoading = payload.isLoading
    },
    updateDirection(state, direction){
    	state.direction = direction
    },
    show_footer(state, Boolean){
    	state.show_footer = Boolean
    },
	updateGlobalVar(state,{name,data}){
		if(name == 'areas'){
			let areas = []
			data.forEach(item=>{
    			if(item.level === 1){
    				areas.push({
    					value: item.area_id,
    					label: item.name,
    					children: []
    				})
    			}
    			if(item.level === 2){
					areas.find(child=>child.value === item.parent_id).children.push({
						value: item.area_id,
    					label: item.name,
    					children: []
					})            				            										
    			}
    			if(item.level === 3){  
    				let parent = data.find(di=>di.area_id === item.parent_id)
    				let top    = areas.find(ci=>ci.value === parent.parent_id)   						
					top.children.find(si=>si.value === item.parent_id).children.push({
						value: item.area_id,
    					label: item.name
					})
    			}            			
    		})
    		Vue.set(state.gvars,name,areas)
		}else{
			Vue.set(state.gvars,name,data)
		}
		
	},
	updateJssdkConfig(state,config){
		/*
		debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    	appId: '', // 必填，公众号的唯一标识
    	timestamp: , // 必填，生成签名的时间戳
    	nonceStr: '', // 必填，生成签名的随机串
    	signature: '',// 必填，签名，见附录1
    	jsApiList: [] /
		 */
		state.jssdk.appId = config.appId
		state.jssdk.debug = config.debug
		state.jssdk.timestamp = config.timestamp
		state.jssdk.nonceStr = config.nonceStr
		state.jssdk.signature = config.signature
		state.jssdk.jsApiList = config.jsApiList
		state.jssdk.ready = true
		state.jssdk.request_time = Math.floor((new Date()).getTime()/1000)

	},
	
	SOCKET_ONOPEN (state, event)  {
      state.socket.isConnected = true
      state.socket.error = false
      state.socket.user_error = ''
      Vue.ws.sendEvent('online',{token:state.user.token,client_type:'mobile'})
    },
    SOCKET_ONCLOSE (state, event)  {
      state.socket.isConnected = false
      state.socket.isUserOnline = false
      state.socket.uid = 0
      state.socket.fd = 0
      state.socket.error = false
      state.socket.user_error = ''
      setTimeout(()=>{
	    Vue.ws.reconnect()
	  },1000)
    },

    SOCKET_ONERROR (state, event){
    	state.socket.error = true
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE (state, event)  {
      let message = event.data
      state.socket.message = message
      let data = JSON.parse(message)
      state.socket.event = data.event
      state.socket.data  = data.data
      if(data.event == 'user:online'){
      	state.socket.isUserOnline = true
      	state.socket.uid = data.data.uid
      	state.socket.fd  = data.data.fd
      }else if(data.event == 'error'){
      	state.socket.user_error = data
      }
      Vue.ws.onUserEvent(data.event,data.data)
    },

    //chat_upload
    openChatUpload(state,path){
    	reset_chat_upload_data(state)
    	state.chat_upload.popup = true
    	state.chat_upload.path  = path
		Vue.ws.sendEvent('create_business_session',{
			uid:state.user.info.uid,
			token:state.user.token,
			base_url:state.base_url+'/student',
			bs_type:'push_media'
		})
		save_chat_upload_state(state)
    },

    closeChatUpload(state){
    	state.chat_upload.popup = false
    	state.chat_upload.started = false
    	Vue.ws.sendEvent('finish_business_session',{
			uid:state.user.info.uid,
			token:state.user.token,
			bs_type:'push_media'
		})
		reset_chat_upload_data(state)
		clear_chat_upload_state()
    },

    startChatUpload(state){
    	state.chat_upload.started = true
    	save_chat_upload_state(state)
    },

    stopChatUpload(state){
    	state.chat_upload.started = false
    	save_chat_upload_state(state)
    },

    recoverChatUpload(state,cu){
    	state.chat_upload.popup = cu.popup
    	state.chat_upload.started = cu.started
    	state.chat_upload.status = cu.status
    	state.chat_upload.msg = cu.msg
    	state.chat_upload.path = cu.path
    	state.chat_upload.data.file_url = cu.file_url
    	state.chat_upload.data.file_type = cu.file_type
    	state.chat_upload.data.file_size = cu.file_size

    	Vue.ws.sendEvent('create_business_session',{
			uid:state.user.info.uid,
			token:state.user.token,
			bs_type:'push_media'
		})
    },

    updateChatUpload(state,session){
    	if(session.status > 0 && session.status < 100){
    		state.chat_upload.msg = session.msg
    	}else if(session.status == 100){
    		state.chat_upload.data.file_url = session.data.file_url
    		state.chat_upload.data.file_type = session.data.file_type
    		state.chat_upload.data.file_size = session.data.file_size
    	}
    	state.chat_upload.status = session.status
    	save_chat_upload_state(state)
    },
    setLayout(state,vm){
		state.layout = vm
	},
	autoLogin(state,params) {
		Vue.localStorage.set('student_login_params',JSON.stringify(params))
	},
	setHwTab(state,tab) {
		state.hw_tab = tab
	}
}


// WEBPACK FOOTER //
// ./src/store/mutations.js